import { Badge } from "@admin-ui/components/primitives/base/badges/badges";
import { Stars01 } from "@untitledui/icons";

interface AiSuggestedBadgeProps {
  field: string;
  origins: Record<string, "ai" | "admin">;
  touched: string[];
  onRevert: (field: string) => void;
}

export function AiSuggestedBadge({ field, origins, touched, onRevert }: AiSuggestedBadgeProps) {
  if (origins[field] !== "ai" || touched.includes(field)) return null;

  return (
    <button
      type="button"
      onClick={() => onRevert(field)}
      title="Click to revert this AI suggestion"
      className="ml-2 inline-flex"
    >
      <Badge color="brand" size="sm">
        <Stars01 className="size-3" />
        AI
      </Badge>
    </button>
  );
}
